import { render, staticRenderFns } from "./TrainingPlanHistory.vue?vue&type=template&id=2f976bca&scoped=true&"
import script from "./TrainingPlanHistory.vue?vue&type=script&lang=js&"
export * from "./TrainingPlanHistory.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPlanHistory.vue?vue&type=style&index=0&id=2f976bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f976bca",
  null
  
)

export default component.exports